// UI Components
import DialogPanel from '@/components/ui/DialogPanel/DialogPanel.vue';
import Navigation from '@/components/ui/Navigation/Navigation.vue';

export default {
  name: 'app',

  components: {
    DialogPanel,
    Navigation
  },

  mounted:function(){
    // App starting up on login page? If so hide navigation
    if(this.$route.name != 'Login' && this.$route.name != 'ResetPassword') {
      this.showNavigation = true;
    }
  },

  data:function(){
    return{
      transitionName: null,
      showNavigation: false
    }
  },

  methods:{

  },

  watch: {
    // Watch for route changes
    '$route' (to, from) {

      this.transitionName = 'fade';
      this.showNavigation = true;

      // To Login from anywhere
      if(to.name == 'Login' || to.name == 'ResetPassword')
      {
        this.showNavigation = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.js